import { type IdentityRefFragment } from '@spotify/confidence-graphql';
import {
  IdentityInline,
  identityKind,
  useCurrentIdentity,
} from '@spotify/plugin-confidence-iam-react';

import { useChatContext } from '../ChatThread/ChatContext';

import styles from './UserMessageAuthor.module.css';

const SERVICE_AUTHOR_DISPLAY_NAME = 'Confidence';

interface UserMessageAuthorProps {
  author: IdentityRefFragment;
}

export const UserMessageAuthor = ({ author }: UserMessageAuthorProps) => {
  const isChildTranscript = useChatContext()?.isChildTranscript ?? false;
  const { currentIdentity, isLoading } = useCurrentIdentity({
    skip: isChildTranscript,
  });

  if (isChildTranscript || isLoading || currentIdentity?.name === author.name) {
    return null;
  }

  const displayedAuthor =
    identityKind(author.name) === 'service'
      ? { ...author, displayName: SERVICE_AUTHOR_DISPLAY_NAME }
      : author;

  return (
    <div className={styles.author}>
      <IdentityInline identityRef={displayedAuthor} />
    </div>
  );
};
